import {Component, HostBinding, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject } from 'rxjs';
import { MatPaginator as MatPaginator, PageEvent as PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {TenderDataSource} from '../../dataSources/tenderDataSource';
import {ArticleService} from '../../services/article.service';
import {Router} from '@angular/router';
import {ShoppingService} from '../../services/shopping.service';
import {NotifyService} from '../../../brover-notify/services/notify.service';
import {FilterService} from '../../services/filter.service';

@Component({
    selector: 'brover-tenders',
    templateUrl: './tenders.component.html',
    standalone: false
})
export class TendersComponent implements OnInit {
  @HostBinding('class.brover-tenders') hasClass = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public displayedColumns: string[] = ['id', 'reference', 'amount', 'action'];
  public dataSource: TenderDataSource | null;

  public itemsPerPage = 10;
  public itemsTotal = 0;
  public pageIndex = 0;

  private tenders: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  private searchValue: string;

  constructor(private articleService: ArticleService, private router: Router, public shoppingService: ShoppingService,
              private notify: NotifyService, public filterService: FilterService) { }

  ngOnInit() {
    this.loadCarts();
  }

  public applyFilter(filterValue: string) {
    this.searchValue = filterValue.trim().toLowerCase();
    if (this.pageIndex > 0) {
      this.pageIndex = 0;
    }

    this.loadCarts();
  }

  public changePage(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.itemsPerPage = event.pageSize;

    this.loadCarts();
  }

  private loadCarts() {
    this.articleService.getCards(this.pageIndex, this.itemsPerPage, this.searchValue).subscribe(x => {
      this.tenders.next(x.carts);
      this.dataSource = new TenderDataSource(this.tenders, this.sort);
      this.itemsTotal = x.carts.length;
    });
  }

  public deleteCard(id: number) {
    if (confirm('Weet je zeker dat je dit deze opgeslagen order wilt verwijderen')) {
      this.articleService.deleteCard(id).subscribe(() => {
        this.notify.success('Opgeslagen order verwijderd');
      });
    }
  }

  public orderNow(row: any) {
    const order = this.shoppingService.order;
    order.shoppingBag = Object.assign(row.items);

    this.filterService.brand = row.brand;
    this.filterService.type = row.car_type;

    order.brand = this.filterService.brand;
    order.car_type = this.filterService.type;

    order.id = row.id;
    order.references = row.reference;

      this.router.navigate(['/', 'dashboard', 'place-order', 'overview', 'ordered', false], { queryParams: { from: 'tenders', tenderId: row.id } });
  }
}
